import { render, staticRenderFns } from "./AddRiskScenarioPanel.vue?vue&type=template&id=03f3c61b&"
import script from "./AddRiskScenarioPanel.vue?vue&type=script&lang=js&"
export * from "./AddRiskScenarioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports